import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectSkinById, setEditId } from "../../../store/roblox/skinsSlice";
import { destroySkin, fetchSkin } from "../../../actions/roblox/skinsActions";
import robloxUrls from "../../../configs/roblox/robloxUrls";

import {
  LikeOutlined,
  HeartOutlined,
  MessageOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "../../../componets/IconText";
import StatsIcons from "../../../componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Details from "./_partials/_Details";
import { ButtonDestroy, ButtonEdit } from "../../../componets/Buttons";
import Comments from "./_partials/_Comments";
import EditComment from "../Comments/Edit";

const Show: React.FC = () => {
  const { id }      = useParams();
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const skin = useAppSelector(state => id ? selectSkinById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchSkin(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    dispatch(setEditId(id));
  }

  function onClickDestroy() {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroySkin(id));

    if (destroySkin.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      const url = skin?.target_id === 0 ? robloxUrls.contentPath() : robloxUrls.communityPath();
      setTimeout(() => navigate(url), 1000);
    }

    if (destroySkin.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-skins-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            skin &&
              <SummaryShow
                title={skin.title}
                image={skin.thumbnail_url}
                createdAt={skin.created_at}
                updatedAt={skin.updated_at}
                className='v-mb-15'
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />,
                ]}
              />
          }

          <StatsIcons
            icons={[
              <IconText tooltip='popular' icon={HeartOutlined} text={skin?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={skin?.likes_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={skin?.comments_count} />,
              <IconText tooltip='downloads' icon={DownloadOutlined} text={skin?.downloads_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='stickers'
          items={[
            { label: 'Details', key: 'details', children: <Details skin={skin} /> },
            { label: 'Comments', key: 'comment', children: <Comments skinId={skin?.id} /> }
          ]}
        />
      </div>

      <SidebarShow id={id} />

      <Edit />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
